<aside class="creator-rail" aria-label="HeyJivu creator navigation">
  <a class="creator-brand" routerLink="/edit" aria-label="HeyJivu home">
    <span class="hj-brand-mark hj-brand-mark--nav" aria-hidden="true">
      <span class="hj-brand-face">
        <span class="hj-brand-eye hj-brand-eye--left"></span>
        <span class="hj-brand-eye hj-brand-eye--right"></span>
        <span class="hj-brand-smile"></span>
        <span class="hj-brand-spark hj-brand-spark--one"></span>
        <span class="hj-brand-spark hj-brand-spark--two"></span>
      </span>
    </span>
    <span class="hj-brand-word creator-brand__word">
      <span class="hj-brand-hey">hey</span>
      <span class="hj-brand-jivu">jivu</span>
    </span>
  </a>

  <nav class="creator-rail__nav" aria-label="Creator destinations">
    @for (destination of desktopDestinations; track destination.id) {
      <a
        class="creator-rail__link"
        [class.is-active]="isActive(destination)"
        [routerLink]="destination.route"
        [attr.aria-current]="isActive(destination) ? 'page' : null"
      >
        <span class="creator-rail__icon" aria-hidden="true">
          <i class="fas" [class]="destination.icon"></i>
        </span>
        <span>{{ destination.label }}</span>
      </a>
    }
  </nav>

  <div class="creator-rail__footer">
    <a class="creator-rail__all-tools" routerLink="/quick-tools">
      <i class="fas fa-grip" aria-hidden="true"></i>
      <span>All tools</span>
    </a>
    <button
      class="creator-rail__upgrade"
      type="button"
      aria-haspopup="dialog"
      [attr.aria-expanded]="upgradePaymentOpen()"
      (click)="openUpgradePayment()"
    >
      <span>
        <strong>Unlock more creation</strong>
        <small>View plans and limits</small>
      </span>
      <i class="fas fa-arrow-right" aria-hidden="true"></i>
    </button>
  </div>
</aside>

<header class="creator-utility-bar">
  <a class="creator-utility-bar__mobile-brand" routerLink="/edit" aria-label="HeyJivu home">
    <span class="hj-brand-mark hj-brand-mark--mobile" aria-hidden="true">
      <span class="hj-brand-face">
        <span class="hj-brand-eye hj-brand-eye--left"></span>
        <span class="hj-brand-eye hj-brand-eye--right"></span>
        <span class="hj-brand-smile"></span>
      </span>
    </span>
    <span>HeyJivu</span>
  </a>

    <a class="creator-tool-finder" routerLink="/search">
      <i class="fas fa-magnifying-glass" aria-hidden="true"></i>
      <span>Find a tool</span>
    </a>

  <div class="creator-utility-bar__actions">
    <a class="creator-utility-button" routerLink="/quick-tools" aria-label="Open all tools">
      <i class="fas fa-grip" aria-hidden="true"></i>
    </a>
    <div class="creator-jivu-control" (click)="keepVoiceMenuOpen($event)">
      <button
        class="creator-jivu-control__trigger"
        [class.is-active]="uiStore.isGlobalMicActive()"
        type="button"
        aria-haspopup="menu"
        [attr.aria-expanded]="voiceMenuOpen()"
        [attr.aria-label]="uiStore.isGlobalMicActive() ? 'Turn off Jivu' : 'Open Jivu voice options'"
        [title]="uiStore.isGlobalMicActive() ? 'Turn off Jivu' : 'Talk to Jivu'"
        (click)="toggleJivuControl($event)"
      >
        @if (uiStore.isGlobalMicActive()) {
          <span class="hj-brand-mark hj-brand-mark--voice-control" aria-hidden="true">
            <span class="hj-brand-face">
              <span class="hj-brand-eye hj-brand-eye--left"></span>
              <span class="hj-brand-eye hj-brand-eye--right"></span>
              <span class="hj-brand-smile"></span>
              <span class="hj-brand-spark hj-brand-spark--one"></span>
              <span class="hj-brand-spark hj-brand-spark--two"></span>
            </span>
          </span>
        } @else {
          <i class="fas fa-microphone" aria-hidden="true"></i>
        }
      </button>

      @if (voiceMenuOpen() && !uiStore.isGlobalMicActive()) {
        <div class="creator-jivu-menu" role="menu" aria-label="Jivu voice mode">
          <div class="creator-jivu-menu__heading">
            <span class="hj-brand-mark hj-brand-mark--voice-menu" aria-hidden="true">
              <span class="hj-brand-face">
                <span class="hj-brand-eye hj-brand-eye--left"></span>
                <span class="hj-brand-eye hj-brand-eye--right"></span>
                <span class="hj-brand-smile"></span>
              </span>
            </span>
            <span><strong>Ask Jivu</strong><small>Choose how you want help</small></span>
          </div>
          <button
            type="button"
            role="menuitem"
            [disabled]="!canUseTalkMode()"
            (click)="startJivuMode('talk', $event)"
          >
            <span><i class="fas fa-comment-dots" aria-hidden="true"></i></span>
            <span>
              <strong>Talk</strong>
              <small>{{ canUseTalkMode() ? 'Have a conversation with Jivu' : 'Available on paid plans' }}</small>
            </span>
          </button>
          <button type="button" role="menuitem" (click)="startJivuMode('work', $event)">
            <span><i class="fas fa-compass" aria-hidden="true"></i></span>
            <span>
              <strong>Tool navigation</strong>
              <small>Say a tool name to open it</small>
            </span>
          </button>
          <a routerLink="/me/settings/language" role="menuitem" (click)="closeVoiceMenu()">
            <i class="fas fa-language" aria-hidden="true"></i>
            <span>Jivu language</span>
            <i class="fas fa-chevron-right" aria-hidden="true"></i>
          </a>
        </div>
      }
    </div>
    <a
      class="creator-avatar"
      routerLink="/me"
      [attr.aria-label]="'Open profile for ' + authStore.displayName()"
      [title]="authStore.displayName()"
    >
      @if (profileAvatar.avatarUrl(); as avatarUrl) {
        <img [src]="avatarUrl" alt="" />
      } @else {
        {{ authStore.userInitials() || 'J' }}
      }
    </a>
  </div>
</header>

<nav class="creator-mobile-nav" aria-label="Mobile creator navigation">
  @for (destination of mobileDestinations; track destination.id) {
    <a
      class="creator-mobile-nav__link"
      [class.is-active]="isActive(destination)"
      [routerLink]="destination.route"
      [attr.aria-current]="isActive(destination) ? 'page' : null"
    >
      <span class="creator-mobile-nav__icon" aria-hidden="true">
        <i class="fas" [class]="destination.icon"></i>
      </span>
      <span>{{ destination.label }}</span>
    </a>
  }
</nav>

<app-manual-payment-upgrade-modal
  [open]="upgradePaymentOpen()"
  [welcomeFreePlan]="false"
  (closed)="closeUpgradePayment()"
  (submitted)="onUpgradePaymentSubmitted($event)"
></app-manual-payment-upgrade-modal>
